import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = checking, false = logged out
  const [token, setToken] = useState(localStorage.getItem("bjrc_token") || null);

  useEffect(() => {
    const check = async () => {
      if (!token) { setUser(false); return; }
      try {
        const { data } = await api.get("/auth/me");
        setUser(data);
      } catch {
        localStorage.removeItem("bjrc_token");
        setToken(null);
        setUser(false);
      }
    };
    check();
    // eslint-disable-next-line
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("bjrc_token", data.token);
    setToken(data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("bjrc_token");
    setToken(null);
    setUser(false);
  };

  const refreshUser = async () => {
    try { const { data } = await api.get("/auth/me"); setUser(data); return data; } catch { return null; }
  };

  const hasRole = (...roles) => user && (user.role === "super_admin" || roles.includes(user.role));

  return (
    <AuthContext.Provider value={{ user, login, logout, hasRole, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
